const api = `api`;
const baseUrl = `https://agastya-hospitals-backend.onrender.com`;
// const baseUrl = `http://localhost:5000`;
export const LOGIN_URL = `${baseUrl}/${api}/auth/login`;
export const REGISTER_URL = `${baseUrl}/${api}/auth/register`;
export const VERIFY_MOBILE_RESET_URL = `${baseUrl}/${api}/auth/verify-mobile-reset`;
export const FORGOT_PASSWORD_URL = `${baseUrl}/${api}/auth/forgot-password`;
export const DOCTORS_API = `${baseUrl}/${api}/doctors`;
export const SPECIALITIES_API = `${baseUrl}/${api}/specialities`;
export const SPECIALITY_BY_ID_API = `${baseUrl}/${api}/specialities`;
export const DEPARTMENTS_API = `${baseUrl}/${api}/departments`;
export const SPECIALITIES_API_DROPDOWN = `${baseUrl}/${api}/specialities/specialityList`;
export const USER_ROLES_API = `${baseUrl}/${api}/user-roles`;
export const MODULES_API = `${baseUrl}/${api}/modules`;
export const USERS_API = `${baseUrl}/${api}/users`;
export const HEALTH_PACKAGES_API = `${baseUrl}/${api}/health-packages`;
export const PATIENTS_API = `${baseUrl}/${api}/patients`;
export const PATIENT_VERIFY_API = `${baseUrl}/${api}/patients/verify`;
export const UPDATE_PATIENT = `${baseUrl}/${api}/patients`;
export const SLOTS_API = `${baseUrl}/${api}/doctor-slots`;
export const APPOINTMENTS_API = `${baseUrl}/${api}/appointments`;
export const UPDATE_APPOINTMENT_API = `${baseUrl}/${api}/appointments`;
export const BLOGS_API = `${baseUrl}/${api}/blogs`;
export const CREATE_BLOGS_API = `${baseUrl}/${api}/blogs`;
export const UPDATE_BLOGS_API = `${baseUrl}/${api}/blogs`;
export const DELETE_BLOGS_API = `${baseUrl}/${api}/blogs`;
export const TECHNOLOGIES_API = `${baseUrl}/${api}/technologies`;
export const UpdatePassword_URL = `${baseUrl}/${api}/auth/update-password`;
export const TESTIMONIALS_API = `${baseUrl}/${api}/testimonials`;
export const SMS_API = `${baseUrl}/${api}/sms`;

export const TaskApi = `${api}/task.json`;
export const BookmarkApi = `${api}/bookmark.json`;
export const ChartistApi = `${api}/chartistData.json`;
export const ChartjsApi = `${api}/chartjsData.json`;
export const ChatMemberApi = `${api}/chatMember.json`;
export const ChatApi = `${api}/chat.chats.json`;
export const ContactApi = `${api}/contacts.json`;
export const ProductsApi = `${api}/product.json`;
export const EmailApi = `${api}/email.json`;
export const ImageLightApi = `${api}/image-light.json`;
export const BigImageApi = `${api}/image-big-light.json`;
export const MasonryApi = `${api}/masonry.json`;
export const GooglechartApi = `${api}/googleChartData.json`;
export const AllProjectApi = `${api}/allProject.json`;
export const SearchAllTabsApi = `${api}/searchAllTabs.json`;
export const TableDataApi = `${api}/tableData.json`;
export const HoverableRowsTable = `${api}/hoverableRowsTable.json`;
export const TodoApi = `${api}/todo.json`;
export const JobSearchApi = `${api}/jobSearch.json`;
export const LearningApi = `${api}/learning.json`;
export const KnowledgebaseApi = `${api}/knowledgebaseDB.json`;
export const FaqApi = `${api}/Faq.json`;
export const FileApi = `${api}/files.json`;
export const UserCardApi = `${api}/usercard.json`;
export const UserEditTableAPI = `${api}/user-edit-table.json`;
export const StickyApi = `${api}/sticky.json`;
export const TypeaheadDataApi = `${api}/typeaheadData.json`;
export const FeatherDataApi = `${api}/featherData.json`;
export const FlagIconDataApi = `${api}/flagIconData.json`;
export const FontawsomeDataApi = `${api}/fontawsomeData.json`;
export const IcoDataApi = `${api}/icoData.json`;
export const ThemifyDataApi = `${api}/themifyData.json`;
